<template>
  <article class="circle-card">
    <figure class="figure">
      <component :is="icon" />
    </figure>
    <h3 class="title">{{ title }}</h3>
    <p class="content">{{ description }}</p>
  </article>
</template>

<script>
export default {
  name: 'CircleCard',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.circle-card {
  border-radius: 10px;
  background-color: $c-brown;
  color: white;
  padding: 46px 28px 50px 28px;
  margin: 0 20px;
  max-width: 320px;
  width: 100%;

  @media (max-width: 349px) {
    max-width: 300px;
  }
}

.figure {
  position: relative;
  width: 240px;
  height: 201px;
  margin: 0 auto 30px;
  text-align: center;
  font-size: 0;
}

.title {
  font-size: $fs-h3;
  text-align: center;
  margin: 0;
}

.content {
  margin-bottom: 0;
}
</style>
